import { render, staticRenderFns } from "./NsTab.vue?vue&type=template&id=164c810f&scoped=true&"
import script from "./NsTab.vue?vue&type=script&lang=js&"
export * from "./NsTab.vue?vue&type=script&lang=js&"
import style0 from "./NsTab.vue?vue&type=style&index=0&id=164c810f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164c810f",
  null
  
)

export default component.exports